import React, { useEffect, useState } from "react";
import { UserX, X } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function DeactivateUserForm({ account, users, onDone }) {
  const [counts, setCounts] = useState(null), [target, setTarget] = useState("");
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    api.get(`/company/users/${account.id}/workload`).then(({ data }) => { if (active) setCounts(data); })
      .catch(e => { if (active) setError(formatApiError(e)); });
    return () => { active = false; };
  }, [account.id]);
  const total = counts ? counts.customers + counts.leads : 0;
  const submit = async e => {
    e.preventDefault();
    if (busy || !counts) return;
    setBusy(true); setError("");
    try { await api.put(`/company/users/${account.id}`, { active: false, transfer_to_id: target || null }); onDone(true); }
    catch (e) { setError(formatApiError(e)); } finally { setBusy(false); }
  };
  return <form onSubmit={submit} className="border-y border-slate-200 py-4 space-y-3" aria-label="İş devri ve hesabı pasife alma">
    <div className="flex items-center justify-between gap-3"><h3 className="font-semibold">{account.name} · Hesabı pasife al</h3><button type="button" disabled={busy} onClick={() => onDone(false)} className="btn-secondary" aria-label="İş devrini kapat"><X size={16} /></button></div>
    {counts ? <p>{counts.customers} müşteri · {counts.leads} açık web talebi</p> : <p>İşler kontrol ediliyor…</p>}
    {total > 0 && <label className="block"><span className="text-sm font-semibold">Devralacak kişi</span><select className="input mt-1" required disabled={busy} value={target} onChange={e => setTarget(e.target.value)}><option value="">Kişi seçin</option>{users.filter(u => u.id !== account.id && u.active !== false && ["admin", "manager", "agent"].includes(u.role)).map(u => <option key={u.id} value={u.id}>{u.name}</option>)}</select></label>}
    <p className="text-sm text-slate-500">Geçmiş görüşmeler, satışlar ve komisyon kayıtları değişmez. Hesabın mevcut oturumları kapatılır.</p>
    {error && <p role="alert" className="text-red-700">{error}</p>}
    <button className="btn-primary" disabled={busy || !counts || (total > 0 && !target)}><UserX size={16} />{busy ? "İşleniyor…" : total > 0 ? "İşleri devret ve pasife al" : "Pasife al"}</button>
  </form>;
}
